/**
 * A full-page navigation to another HubHive site (the Shop, ProFinder), or to
 * a HubHive app through its URL scheme (Loop on a Mac, ADR-0158).
 * `next/navigation`'s router only knows this app's routes, and jsdom's
 * `window.location` cannot be stubbed, so the one call lives here where tests
 * can mock it.
 */
export function leaveSite(href: string): void {
  window.location.assign(href)
}
